/**
 * responsive.js — 모바일 반응형 유틸리티
 *
 * JS/CSS 역할 경계:
 * - JS (이 파일): pageSize, 차트 높이/마진 등 데이터 로직 전용
 * - DOM 가시성 (컬럼 숨김/표시): Tailwind CSS 클래스 사용 (hidden sm:table-cell 등)
 *
 * isMobileViewport()를 DOM 요소 가시성 제어에 사용하지 말 것.
 * 대신 Tailwind의 반응형 유틸리티 클래스를 사용할 것.
 */
export const MOBILE_MAX_WIDTH = 640;

export const isMobileViewport = () => {
    if (typeof window === "undefined") {
        return false;
    }
    const viewportWidth = window.visualViewport?.width ?? window.innerWidth;
    if (window.matchMedia) {
        return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
    }
    return viewportWidth <= MOBILE_MAX_WIDTH;
};
